module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/champion-896618327269593eecc2cbe458e67ebf.svg";